import React, { FC } from "react";

import { Smile, DownOutlined } from "@ctra/components";
import { IdaQnAsEventStatus } from "@ctra/api";
import { Enterprise, useTranslation } from "@ctra/i18n";
import { classname } from "@ctra/utils";

import { IdaQnAEvent, IdaQnAStatus, testIds, useEvent } from "@events";
import styles from "./IdaQnAsEventExpandIcon.module.less";

type IdaQnAsEventExpandIconProps = {
  /**
   * Angle of rotation for the icon
   */
  rotate: number;
  /**
   * Expanded state
   */
  expanded: boolean;
};

/**
 * IdaQnAsEvent ExpandIcon component
 * @param {number} rotate
 * @param {boolean} expanded
 * @return {JSX.Element}
 * @constructor
 */
export const IdaQnAsEventExpandIcon: FC<IdaQnAsEventExpandIconProps> = ({ rotate, expanded }) => {
  const { event } = useEvent<IdaQnAEvent>();
  const { t } = useTranslation();

  const {
    events: {
      entity: { status }
    }
  } = Enterprise;

  return (
    <div className={styles.Wrapper} data-testid={testIds.expandIcon}>
      <div className={classname(styles.TagBase, styles.StatusBase, styles.Initial)}>
        <Smile /> &nbsp;
        {/* The one below is basically "Ask" */}
        {t<string>(status(event.source.type), {
          status: IdaQnAsEventStatus.initial
        })}
      </div>
      <IdaQnAStatus expanded={expanded} />
      <DownOutlined rotate={rotate} />
    </div>
  );
};
